import { ColorRecipeModel } from '../../models/color-recipe.model';
import { PaintBrushMode } from '../../models/paint-brush-mode.enum';

export class EditPaintStateModel {
    colorRecipe: ColorRecipeModel;
    brushMode: PaintBrushMode;
}
